import { render, staticRenderFns } from "./tentang.vue?vue&type=template&id=354ae47e"
import script from "./tentang.vue?vue&type=script&lang=js"
export * from "./tentang.vue?vue&type=script&lang=js"
import style0 from "./tentang.vue?vue&type=style&index=0&id=354ae47e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports